import { useQuery } from "~/libs";

import { ApiClient } from "~/utils";

import { ApiManagersAiGeneratedCompanyPostSummariesShowResponseType } from "~/domains";

const request = () => {
  return new ApiClient()
    .get<ApiManagersAiGeneratedCompanyPostSummariesShowResponseType>(
      "/api/managers/ai_generated_company_post_summary",
    )
    .then((res) => res.data);
};

export const useApisManagersAiGeneratedCompanyPostSummariesShow = ({
  options = {},
} = {}) => {
  return useQuery(
    ["ApisManagersAiGeneratedCompanyPostSummariesShow"],
    request,
    {
      ...options,
    },
  );
};
